import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _extends from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["Component", "pageProps", "headerProps", "configFlags"];
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import merge from "lodash-es/merge";
import App from "next/app";
import { CART_APOLLO_CACHE_CONFIG } from "@catchoftheday/cart-components";
import { CMS_CONFIG_APOLLO_CACHE_CONFIG, nextAppHOC } from "@catchoftheday/common-vendors";
import { getEnvConfig, withEnvConfig } from "@catchoftheday/env-config";
import { headerInitialProps } from "@catchoftheday/header";
import { ONEPASS_SHOP_APOLLO_CACHE_CONFIG } from "@catchoftheday/onepass";
import { GlobalAppProvider } from "../contexts/GlobalAppProvider";
import { PageLayout } from "../layouts/PageLayout";
import { jsx as ___EmotionJSX } from "@emotion/react";

function ShopfrontApp(_ref) {
  var Component = _ref.Component,
      pageProps = _ref.pageProps,
      headerProps = _ref.headerProps,
      configFlags = _ref.configFlags,
      rest = _objectWithoutProperties(_ref, _excluded);

  var host = rest.host;

  var _ref2 = pageProps || {},
      disablePageLayout = _ref2.disablePageLayout;

  if (disablePageLayout) {
    return ___EmotionJSX(GlobalAppProvider, null, ___EmotionJSX(Component, _extends({}, pageProps, rest)));
  }

  return ___EmotionJSX(PageLayout, {
    host: host,
    headerProps: headerProps,
    configFlags: configFlags
  }, ___EmotionJSX(Component, _extends({}, pageProps, rest, {
    host: host
  })));
}

ShopfrontApp.getInitialProps = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(appContext) {
    var appProps, _ref4, configFlags, headerCookies;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return App.getInitialProps(appContext);

          case 2:
            appProps = _context.sent;
            _context.next = 5;
            return headerInitialProps(appContext);

          case 5:
            _context.t0 = _context.sent;

            if (_context.t0) {
              _context.next = 8;
              break;
            }

            _context.t0 = {};

          case 8:
            _ref4 = _context.t0;
            configFlags = _ref4.configFlags;
            headerCookies = _ref4.headerCookies;
            return _context.abrupt("return", _objectSpread(_objectSpread({}, appProps), {}, {
              headerProps: {
                headerCookies: headerCookies
              },
              configFlags: configFlags
            }));

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x) {
    return _ref3.apply(this, arguments);
  };
}();

export default withEnvConfig(nextAppHOC({
  graphqlEndpoint: function graphqlEndpoint() {
    return getEnvConfig().GRAPHQL_ENDPOINT;
  },
  apolloCacheConfig: merge(CMS_CONFIG_APOLLO_CACHE_CONFIG, CART_APOLLO_CACHE_CONFIG, ONEPASS_SHOP_APOLLO_CACHE_CONFIG),
  // eslint-disable-next-line n/no-process-env
  connectToDevTools: false,
  fonts: ["biennale", "montserrat"]
})(ShopfrontApp));